import { MIN_WIDTH } from '@/components/property-compare/constants';
import { Property } from '@/types';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { RowHeader } from './row-header';

interface CompareLineProps<T> {
  hideIfEqual?: boolean;
  masterPropertyNumber?: string;
  label: string | ReactNode;
  properties: Property[];
  valueExtractor: (property: Property) => T;
  comparator?: (properties: Property[], property: Property) => number;
  render: (
    value: T,
    comparisionResult: number,
    property: Property,
    properties: Property[],
    masterProperty?: Property
  ) => JSX.Element;
}

export function CompareLine<T>(props: CompareLineProps<T>) {
  if (
    props.hideIfEqual &&
    props.properties.every(
      (property) =>
        props.valueExtractor(property) ===
        props.valueExtractor(props.properties[0])
    )
  ) {
    return null;
  }

  return (
    <tr>
      <RowHeader label={props.label} />
      {props.properties.map((property) => (
        <td
          style={{ minWidth: MIN_WIDTH }}
          key={property.propertyNumber}
          className={clsx(
            'border border-gray-300',
            props.masterPropertyNumber === property.propertyNumber &&
              'bg-gray-50 '
          )}
        >
          {props.render(
            props.valueExtractor ? props.valueExtractor(property) : null,
            props.comparator ? props.comparator(props.properties, property) : 0,
            property,
            props.properties
          )}
        </td>
      ))}
    </tr>
  );
}
